var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'video-wrap': true,
        'right': _vm.isOwn
    }},[(_vm.msgInfo.type!=='lock')?[_c('video',{staticClass:"video",attrs:{"controls":""},on:{"loadeddata":_vm.handleLoadedData}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}}),_vm._v(" Your browser does not support the video tag. ")])]:_c('div',{staticClass:"lock",on:{"click":function($event){return _vm.handleUnlock(_vm.msgInfo)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }